(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scaling-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scaling-hero-slider')) {
    class ScalingHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pauseButton = this.querySelector('[data-pause]');
        this.current = 0;
        this.userPaused = false;
        this.hoverPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = Math.max(2, Number(this.dataset.interval) || 5) * 1000;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.current - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.current + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
        this.pauseButton?.addEventListener('click', () => this.setUserPaused(!this.userPaused));

        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.syncFromScroll(), 80);
        }, { passive: true });

        // Keep the same slide in view when the window is resized
        this.resizeObserver = new ResizeObserver(() => {
          this.track.scrollTo({ left: this.slides[this.current]?.offsetLeft || 0, behavior: 'instant' });
        });
        this.resizeObserver.observe(this.track);

        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.stop(); });
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.start(); });
        this.addEventListener('focusin', () => { this.hoverPaused = true; this.stop(); });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) { this.hoverPaused = false; this.start(); }
        });

        this.onBlockSelect = (event) => {
          const index = this.slides.indexOf(event.target);
          if (index < 0) return;
          this.editorPaused = true;
          this.stop();
          this.go(index, 'instant');
        };
        this.onBlockDeselect = (event) => {
          if (!this.slides.includes(event.target)) return;
          this.editorPaused = false;
          this.start();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.updateState();
        if (this.reducedMotion) this.setUserPaused(true);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      go(index, behavior = 'smooth') {
        const count = this.slides.length;
        if (count < 2) return;
        this.current = (index + count) % count;
        this.track.scrollTo({ left: this.slides[this.current].offsetLeft, behavior });
        this.updateState();
        this.restart();
      }

      syncFromScroll() {
        const width = this.track.clientWidth || 1;
        const index = Math.round(this.track.scrollLeft / width);
        if (index !== this.current && this.slides[index]) {
          this.current = index;
          this.updateState();
          this.restart();
        }
      }

      updateState() {
        this.slides.forEach((slide, i) => {
          const active = i === this.current;
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => {
          if (i === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      setUserPaused(paused) {
        this.userPaused = paused;
        if (this.pauseButton) {
          this.pauseButton.setAttribute('aria-pressed', String(paused));
          const label = this.pauseButton.querySelector('[data-pause-label]');
          if (label) label.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
        }
        paused ? this.stop() : this.start();
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
        if (this.userPaused || this.hoverPaused || this.editorPaused) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.current + 1), this.interval);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        if (this.timer) this.start();
      }
    }

    customElements.define('scaling-hero-slider', ScalingHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
